import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PenaltyAdditonal } from 'src/app/core/models/cancellation-overrides.model';
import { PassengerType } from 'src/app/core/enums/enums';
import { Observable, Subscription } from 'rxjs';
import { InvoluntaryExchangeQuote } from 'src/app/core/models/involuntary-change.model';
import { InvoluntaryChangeService } from 'src/app/involuntary-change/services/involuntary-change.service';

@Component({
  selector: 'app-choose-farebasis',
  templateUrl: './choose-farebasis.component.html'
})
export class ChooseFarebasisComponent implements OnInit, OnDestroy {
  @Output() sendFarebasis = new EventEmitter<string>();
  @Input() type: number;
  @Input() groupName: string;
  @Input() set additionalPenalties(values: PenaltyAdditonal[]) {
    this.penalties = values;
    if (this.type == 2) {
      this.farebasis =
        !!values && !!values.length && !this.farebasis ? values[0].fareBasis : this.farebasis;
    }
  }

  subscriptions = new Subscription();

  public loading$: Observable<boolean>;
  public involuntaryQuote$: Observable<InvoluntaryExchangeQuote>;
  public open: boolean = false;
  public edited: boolean = false;
  public farebasis: string = '';
  public penalties: PenaltyAdditonal[] = [];
  public activeContent: number = 0;
  public penaltiesByTypeUser: any = [];

  constructor(private service: InvoluntaryChangeService) {}

  ngOnInit(): void {
    this.loading$ = this.service.getLoading();
    this.involuntaryQuote$ = this.service.getInvoluntaryQuote();

    if (this.type == 1) {
      this.callType1Subscriptions();
    }
  }

  callType1Subscriptions() {
    this.subscriptions.add(
      this.involuntaryQuote$.subscribe((element_i: any) => {
        const vPassanger = element_i?.passenger;
        const listPassenger = [];
        vPassanger?.forEach((value: any) => {
          listPassenger.push(value.type);
        });
        const unique = listPassenger.filter((value, index, self) => self.indexOf(value) === index);

        this.formatPenaltiesPerUser(unique);

        this.savePenaltiesPerUser();

        this.formatPenaltiesByTypeUser();
      })
    );
  }

  formatPenaltiesPerUser(unique: any[]) {
    unique.forEach((resp) => {
      this.penaltiesByTypeUser.push({
        name: resp,
        passengerType: resp,
        farebasis: '',
        listFareBasis: []
      });
    });
  }

  savePenaltiesPerUser() {
    if (this.penalties && this.penalties?.length > 0) {
      this.penalties.forEach((resp: any, key: number) => {
        resp.passengerTypes.forEach((element: any) => {
          this.penaltiesByTypeUser.forEach((type_passenger: any, key: any) => {
            if (type_passenger.name == element) {
              this.penaltiesByTypeUser[key].listFareBasis.push(resp);
            }
          });
        });
      });
    }
  }

  formatPenaltiesByTypeUser() {
    this.penaltiesByTypeUser.forEach((element: any, key: number) => {
      element.farebasis = element.listFareBasis[0] ? element.listFareBasis[0].fareBasis : '';
    });
  }

  changeContent(element) {
    this.activeContent = element;
  }

  setTypePassanger(type: PassengerType, obj: any) {
    return obj;
  }

  selectFarebasis(farebasis: any) {
    if (this.type == 1) {
      this.penaltiesByTypeUser.forEach((resp: any, key) => {
        if (resp.name == farebasis.passengerTypes[0]) {
          resp.listFareBasis.forEach((element) => {
            if (element.fareBasis == farebasis.fareBasis) {
              resp.farebasis = element.fareBasis;
            }
          });
        }
      });
      this.sendFarebasis.emit(this.penaltiesByTypeUser);
    } else {
      this.sendFarebasis.emit(this.farebasis);
    }
    this.edited = true;
  }

  close() {
    if (this.type == 1) {
      this.sendFarebasis.emit(this.penaltiesByTypeUser);
    } else {
      this.sendFarebasis.emit(this.farebasis);
    }
    this.open = false;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
